let conf = {
	dbserver: {
		_value : '/mc2/es',
		set : server=>{
			if (server) {
				conf.dbserver._value = server;
			}
		},
		get : ()=>conf.dbserver._value
	}
}

export default conf;


// WEBPACK FOOTER //
// ./src/scripts/common/config.js